import { render, staticRenderFns } from "./ScoreboardFOResume.vue?vue&type=template&id=6a2fab0a"
import script from "./ScoreboardFOResume.vue?vue&type=script&lang=js"
export * from "./ScoreboardFOResume.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardFOResume.vue?vue&type=style&index=0&id=6a2fab0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports